import React, { useState } from 'react';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Phone, Mail, Linkedin, Facebook, ChevronDown } from 'lucide-react';
// Declining headcount data showing workforce reduction starting in late 2025
const headcountData = [{
  date: 'Jan-10',
  count: 85
}, {
  date: 'Jul-10',
  count: 88
}, {
  date: 'Jan-11',
  count: 92
}, {
  date: 'Jul-11',
  count: 95
}, {
  date: 'Jan-12',
  count: 98
}, {
  date: 'Jul-12',
  count: 102
}, {
  date: 'Jan-13',
  count: 105
}, {
  date: 'Jul-13',
  count: 108
}, {
  date: 'Jan-14',
  count: 110
}, {
  date: 'Jul-14',
  count: 112
}, {
  date: 'Jan-15',
  count: 115
}, {
  date: 'Jul-15',
  count: 118
}, {
  date: 'Jan-16',
  count: 120
}, {
  date: 'Jul-16',
  count: 118
}, {
  date: 'Jan-17',
  count: 115
}, {
  date: 'Jul-17',
  count: 112
}, {
  date: 'Jan-18',
  count: 110
}, {
  date: 'Jul-18',
  count: 112
}, {
  date: 'Jan-19',
  count: 115
}, {
  date: 'Jul-19',
  count: 118
}, {
  date: 'Jan-20',
  count: 120
}, {
  date: 'Jul-20',
  count: 122
}, {
  date: 'Jan-21',
  count: 125
}, {
  date: 'Jul-21',
  count: 125
}, {
  date: 'Jan-22',
  count: 128
}, {
  date: 'Jul-22',
  count: 130
}, {
  date: 'Jan-23',
  count: 132
}, {
  date: 'Jul-23',
  count: 135
}, {
  date: 'Jan-24',
  count: 138
}, {
  date: 'Jul-24',
  count: 140
}, {
  date: 'Jan-25',
  count: 142
}, {
  date: 'Apr-25',
  count: 142
}, {
  date: 'Jul-25',
  count: 140
}, {
  date: 'Oct-25',
  count: 125
}, {
  date: 'Dec-25',
  count: 95
}, {
  date: 'Feb-26',
  count: 75
}, {
  date: 'Mar-26',
  count: 75
}];
// Declining role data
const roleData = [{
  date: 'Jan-18',
  Sales: 25,
  Operations: 15,
  Accounting: 8,
  HR: 5,
  Engineering: 30,
  CS: 12,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-18',
  Sales: 24,
  Operations: 14,
  Accounting: 8,
  HR: 5,
  Engineering: 28,
  CS: 11,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-19',
  Sales: 23,
  Operations: 14,
  Accounting: 7,
  HR: 5,
  Engineering: 26,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-19',
  Sales: 22,
  Operations: 13,
  Accounting: 7,
  HR: 4,
  Engineering: 24,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-20',
  Sales: 20,
  Operations: 12,
  Accounting: 7,
  HR: 4,
  Engineering: 22,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-20',
  Sales: 18,
  Operations: 12,
  Accounting: 6,
  HR: 4,
  Engineering: 20,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-21',
  Sales: 17,
  Operations: 11,
  Accounting: 6,
  HR: 4,
  Engineering: 18,
  CS: 9,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-21',
  Sales: 16,
  Operations: 10,
  Accounting: 6,
  HR: 3,
  Engineering: 16,
  CS: 9,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-22',
  Sales: 15,
  Operations: 10,
  Accounting: 5,
  HR: 3,
  Engineering: 14,
  CS: 8,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-22',
  Sales: 14,
  Operations: 9,
  Accounting: 5,
  HR: 3,
  Engineering: 12,
  CS: 7,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-23',
  Sales: 13,
  Operations: 8,
  Accounting: 5,
  HR: 3,
  Engineering: 10,
  CS: 6,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-23',
  Sales: 12,
  Operations: 7,
  Accounting: 4,
  HR: 2,
  Engineering: 9,
  CS: 6,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-24',
  Sales: 11,
  Operations: 7,
  Accounting: 4,
  HR: 2,
  Engineering: 8,
  CS: 5,
  Management: 8,
  IT: 0
}, {
  date: 'Jul-24',
  Sales: 10,
  Operations: 6,
  Accounting: 4,
  HR: 2,
  Engineering: 7,
  CS: 5,
  Management: 6,
  IT: 0
}, {
  date: 'Jan-25',
  Sales: 9,
  Operations: 5,
  Accounting: 3,
  HR: 2,
  Engineering: 6,
  CS: 4,
  Management: 6,
  IT: 0
}, {
  date: 'Jul-25',
  Sales: 8,
  Operations: 5,
  Accounting: 3,
  HR: 1,
  Engineering: 5,
  CS: 3,
  Management: 5,
  IT: 0
}];
const departments = [{
  key: 'Sales',
  color: '#4f46e5',
  label: 'Sales'
}, {
  key: 'Operations',
  color: '#0ea5e9',
  label: 'Operations'
}, {
  key: 'Accounting',
  color: '#10b981',
  label: 'Accounting'
}, {
  key: 'HR',
  color: '#f59e0b',
  label: 'Human Resources'
}, {
  key: 'Engineering',
  color: '#8b5cf6',
  label: 'Engineering'
}, {
  key: 'CS',
  color: '#ec4899',
  label: 'Customer Service'
}, {
  key: 'Management',
  color: '#ef4444',
  label: 'Management'
}, {
  key: 'IT',
  color: '#64748b',
  label: 'IT'
}];
const principals = [{
  name: 'Bill Lumbergh',
  role: 'VP Operations',
  phone: '(512) 555-0200',
  email: 'b.lumbergh@initech.com',
  status: 'Current',
  previous: ['Penetrode (1995-2010)'],
  socials: ['linkedin'],
  linkedin: 'https://www.linkedin.com/in/bill-lumbergh/'
}, {
  name: 'Dom Portwood',
  role: 'Senior VP',
  phone: '(512) 555-0201',
  email: 'd.portwood@initech.com',
  status: 'Current',
  previous: [],
  socials: ['linkedin'],
  linkedin: '#'
}, {
  name: 'Nina McInroe',
  role: 'VP Human Resources',
  phone: '(512) 555-0202',
  email: 'n.mcinroe@initech.com',
  status: 'Current',
  previous: [],
  socials: [],
  linkedin: '#'
}];
export function InitechPeopleTab() {
  const [activeDepartments, setActiveDepartments] = useState<string[]>(departments.map(d => d.key));
  const toggleDepartment = (key: string) => {
    if (activeDepartments.includes(key)) {
      setActiveDepartments(activeDepartments.filter(d => d !== key));
    } else {
      setActiveDepartments([...activeDepartments, key]);
    }
  };
  const toggleAll = () => {
    if (activeDepartments.length === departments.length) {
      setActiveDepartments([]);
    } else {
      setActiveDepartments(departments.map(d => d.key));
    }
  };
  return <div className="space-y-6 mt-6" data-id="element-2601" data-mp="mrfo4lyz9pij">
      {/* Employee Headcount Chart */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-2602" data-mp="mt8tlxxuu3oy">
        <div className="flex justify-between items-start mb-6" data-id="element-2603" data-mp="hymjrz7f8j6z">
          <div data-id="element-2604" data-mp="dzngsk592wi6">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-2605" data-mp="dy2o702hxnmy">
              Employee Headcount
            </h2>
            <div className="inline-block border-b-2 border-red-600 pb-1 mb-1" data-id="element-2606" data-mp="1ai1jbcnvvfb4">
              <span className="text-xl font-bold text-red-600" data-id="element-2607" data-mp="15p8fqs45id0m">-47%</span>
            </div>
            <p className="text-sm text-gray-600" data-id="element-2608" data-mp="2odtfqq7f8e2j">12 Month Growth Rate</p>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2609" data-mp="2tb3402j2qjos">
            ALL <ChevronDown className="w-4 h-4" data-id="element-2610" data-mp="2xfsz3p5wru8n" />
          </button>
        </div>
        <div className="h-72 w-full" data-id="element-2611" data-mp="32e45fpwzvmm4">
          <ResponsiveContainer width="100%" height="100%" data-id="element-2612" data-mp="37bnpj6gditlz">
            <LineChart data={headcountData} margin={{
            top: 5,
            right: 0,
            left: -20,
            bottom: 0
          }} data-id="element-2613" data-mp="37bduh4gh1w9f">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2614" data-mp="3h3jun1gvnjzp" />
              <XAxis dataKey="date" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} minTickGap={30} data-id="element-2615" data-mp="3q2wz1fq59idk" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 140]} ticks={[0, 35, 70, 105, 140]} data-id="element-2616" data-mp="30z8chp0ozyjl" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }} data-id="element-2617" data-mp="2n7l6uykv1do5" />
              <Line type="monotone" dataKey="count" stroke="#000000" strokeWidth={2} dot={false} activeDot={{
              r: 6,
              fill: '#000000'
            }} data-id="element-2618" data-mp="2w0x1haynvhzs" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Company Principals Table */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2619" data-mp="1pchibhpn52wq">
        <div className="p-6 border-b border-gray-200" data-id="element-2620" data-mp="1u6bw64ikennw">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-2621" data-mp="1fg4kq8qz64wp">
            Company Principals
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-2622" data-mp="1ke68v839cuf1">
          <table className="w-full text-left border-collapse" data-id="element-2623" data-mp="1kcv2d0ifh8k8">
            <thead data-id="element-2624" data-mp="285ldj7iibntg">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2625" data-mp="2853ans1cabck">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2626" data-mp="2d3wnrjcps0c7">
                  Name
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2627" data-mp="1y5uhh1eat0r9">
                  Role
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2628" data-mp="237jsih1itefc">
                  Phone/Email
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2629" data-mp="rq20ufx7s596">
                  Status
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2630" data-mp="2mo2aq074ujsg">
                  Previous Employers
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 text-right" data-id="element-2631" data-mp="2ro6txxzfdsmd">
                  Socials
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2632" data-mp="2huzqiio8wmox">
              {principals.map((principal, idx) => <tr key={idx} className="hover:bg-gray-50/50" data-id="element-2633" data-mp="23uyhuh1qoayw" data-mpi={idx}>
                  <td className="px-6 py-4" data-id="element-2634" data-mp="28vw7fep2w7af">
                    <span className="font-bold text-gray-900" data-id="element-2635" data-mp="28tjg4axfkkkp">
                      {principal.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-2636" data-mp="1ywn5nznz1odi">
                    {principal.role}
                  </td>
                  <td className="px-6 py-4" data-id="element-2637" data-mp="3ocwbtob1yl8c">
                    <div className="space-y-1" data-id="element-2638" data-mp="3tbhahjanowuo">
                      <div className="flex items-center gap-2 text-sm" data-id="element-2639" data-mp="3ta6ck03w6jbh">
                        <Phone className="w-4 h-4 text-gray-400" data-id="element-2640" data-mp="1hncj49onhrob" />
                        <a href={`tel:${principal.phone}`} className="text-indigo-600 hover:underline" data-id="element-2641" data-mp="1hlrrartq0mu5">
                          {principal.phone}
                        </a>
                      </div>
                      <div className="flex items-center gap-2 text-sm" data-id="element-2642" data-mp="1ml49gz9nd5qe">
                        <Mail className="w-4 h-4 text-gray-400" data-id="element-2643" data-mp="20dao2gx5j4nq" />
                        <a href={`mailto:${principal.email}`} className="text-indigo-600 hover:underline" data-id="element-2644" data-mp="1wdjrtxouvwbt">
                          {principal.email}
                        </a>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-2645" data-mp="fzjtgr5nseqo">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${principal.status === 'Current' ? 'bg-gray-100 text-gray-800 border border-gray-200' : 'bg-red-100 text-red-700 border border-red-200'}`} data-id="element-2646" data-mp="g0lftrs4knnp">
                      {principal.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2647" data-mp="2k4psoocn3bmj">
                    {principal.previous.length > 0 ? <ul className="list-disc list-inside text-sm text-gray-600 space-y-0.5" data-id="element-2648" data-mp="2ozllvrtm4518">
                        {principal.previous.map((prev, i) => <li key={i} data-id="element-2649" data-mp="2yyueohcqrdm0" data-mpi={i}>{prev}</li>)}
                      </ul> : <span className="text-sm text-gray-400" data-id="element-2650" data-mp="33rdyvx5xp6zs">-</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-2651" data-mp="37u0m1krnu3qn">
                    <div className="flex items-center justify-end gap-2" data-id="element-2652" data-mp="3cs272b8ncd4r">
                      {principal.socials.includes('linkedin') && <a href={principal.linkedin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#0077b5] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-2653" data-mp="3ho9cm2x4rmm6">
                          <Linkedin className="w-4 h-4" data-id="element-2654" data-mp="3dvazjhl5edt9" />
                        </a>}
                      {principal.socials.includes('facebook') && <a href="#" className="w-8 h-8 rounded-full bg-[#1877f2] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-2655" data-mp="9gkxbkt7uqbb">
                          <Facebook className="w-4 h-4" data-id="element-2656" data-mp="n7vftd6ced3" />
                        </a>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}